import axios from '@/libs/api.request'

export const getAggregatedSums = () => {
  return axios.request({
    url: 'home/aggregated-sums',
    method: 'get'
  })
}
export const getRecenttActivities = () => {
  return axios.request({
    url: 'home/recent-activities',
    method: 'get'
  })
}
